export function detectMessage(error, resultMessage) {
    if (error) {
        return (resultMessage === null || resultMessage === void 0 ? void 0 : resultMessage.error) || 'FAQの取得に失敗しました';
    }
    return (resultMessage === null || resultMessage === void 0 ? void 0 : resultMessage.success) || '該当はありません';
}
//# sourceMappingURL=detect-message.js.map